import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { GridCloseIcon } from '@mui/x-data-grid'
import { t } from 'i18next'
import { ReactElement } from 'react'

interface Props {
  open: boolean
  title?: string
  handleSave: () => void
  handleClose: () => void
  element: ReactElement
}

const DevelopusDialog = (props: Props) => {
  return (
    <Dialog
      onClose={props.handleClose}
      open={props.open}
      fullWidth={false}
      maxWidth={false}
      PaperProps={{
        style: {
          maxWidth: '95vw', // Set the maximum width of the dialog
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>{props.title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <GridCloseIcon />
      </IconButton>
      <DialogContent
        dividers
        sx={{
          minWidth: '500px !important',
          minHeight: '400px !important',
          width: 'auto',
        }}
      >
        {props.element}
      </DialogContent>
      <DialogActions>
        <Button
          autoFocus
          onClick={props.handleSave}
          style={{ textTransform: 'none' }}
        >
          {t('common.save')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DevelopusDialog
